import { PhosphorCheckButton, PhosphorXButton } from "components/Atoms/PhosphorIconButton";
import React from "react";

interface SaveOrCancelButtonProps {
  onSave: () => void
  onCancel: () => void
  inline?: boolean
}

export const SaveOrCancelButtons = (props: SaveOrCancelButtonProps) => {
  return <div className={props.inline ? "main-section-template-buttons-inline" : "main-section-template-buttons"}>
    <div className="main-section-template-button-wrapper">
      <PhosphorCheckButton className="main-section-template-save-button" layout="in-square" onClick={props.onSave} />
    </div>
    <div className="main-section-template-button-wrapper">
      <PhosphorXButton className="main-section-template-cancel-button" layout="in-square" onClick={props.onCancel} />
    </div>
  </div>
}